import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DocsArticle"] */ "/root/repo/src/components/docs/article.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApiAuthorization"] */ "/root/repo/src/components/docs/nexum/authorization.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApiEndpoint"] */ "/root/repo/src/components/docs/nexum/endpoint.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApiExamples"] */ "/root/repo/src/components/docs/nexum/examples.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApiResponseGroup"] */ "/root/repo/src/components/docs/nexum/response-group.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApiSchema"] */ "/root/repo/src/components/docs/nexum/schema.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DocsPageTools"] */ "/root/repo/src/components/docs/page-tools.tsx");
